import React from "react";

function CryptoGamingHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover text-center flex items-start"
        style={{
          backgroundImage: "url(assets/img/bg/launch_your_own_crypto_img.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <div className="container mx-auto px-4 pt-[270px] pb-20">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
              Crypto Gaming App Development
            </h2>

            <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
              At Xeer Technology, we empower game developers & businesses to
              embrace the future with innovative crypto gaming solutions. Our
              Crypto Gaming App Development services are designed to help you
              launch blockchain-based games that offer immersive experiences &
              unique monetization opportunities.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CryptoGamingHero;
